import { TransformConvertorBase } from './transform.convertor';
import { Transformation } from 'app/model/dataflow/transformation';
import { DataFlowExpressionUtils } from 'app/model/adapters/dataflow/expression.util';
import {
    ExpressionColumnPlainObject,
    ExpressionColumnPatternPlainObject
} from 'worker/app-workers/shared/plainObjects/expressionColumn.plainObject';
import { SchemaModifierBasePlainObject } from 'worker/app-workers/shared/plainObjects/schemaModifierBase.plainObject';
import { BaseSchemaModifierTransformation } from 'app/model/dataflow/base-schema-modifier-transformation';
import { DataFlowSchemaAdapterUtils } from 'app/model/adapters/dataflow/dataflow-schema-adapter-utils';
import { IResourceContext } from 'shell-models-lib';

export abstract class SchemaModifierBaseConvertor extends TransformConvertorBase {
    private get transformBase(): BaseSchemaModifierTransformation {
        return this.transformation as BaseSchemaModifierTransformation;
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        await super.convert(contextData);
        (this.transformObject as SchemaModifierBasePlainObject).columns.forEach((column) => {
            if (column.classType === ExpressionColumnPlainObject.classType) {
                const expressionPlainObjectColumn = column as ExpressionColumnPlainObject;
                const newColumn = expressionPlainObjectColumn.transient
                    ? this.transformBase.addTransientColumn()
                    : this.transformBase.addColumn();
                newColumn.column.name = expressionPlainObjectColumn.name;
                newColumn.dataFlowExpression.expression = DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(
                    expressionPlainObjectColumn.expression
                );
                newColumn.fixedReturnTypeExpression.expression = DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(
                    expressionPlainObjectColumn.typeExpression
                );
                newColumn.column.isTransient = expressionPlainObjectColumn.transient;
            } else if (column.classType === ExpressionColumnPatternPlainObject.classType) {
                DataFlowSchemaAdapterUtils.addColumnPatternToTransform(
                    this.transformBase,
                    column as ExpressionColumnPatternPlainObject
                );
            }
        });
        super.postConvert();
        return this.transformation;
    }
}
